<template>
  <div class="personal-detail-1">
    <el-form :model="formData" label-position="top" :rules="rules" status-icon ref="ruleForm" class="demo-ruleForm">
      <div class="form-tip"><i class="time-icon-color el-icon-time"></i>{{$t('personalDetails1.estimatedTime')}}</div>
      <el-row :gutter="20">
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="fixed-high">
          <el-row :gutter="20">
            <el-col :xs="10" :sm="10" :md="10" :lg="10" :xl="10">
              <el-form-item :label="$t('personalDetails1.Title')" prop="Title">
                <el-select @visible-change="$elui_Select_Edge"  v-model="formData.Title" class="select-width" :placeholder="$t('messages.unSelect')">
                  <el-option v-for="(item,index) in $t('personalDetails1.titleSelect')" :key="index" :label="item"
                    :value="index">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="14" :sm="14" :md="14" :lg="14" :xl="14">
              <el-form-item :label="$t('personalDetails1.First_Name')" prop="First_Name">
                <el-input v-model="formData.First_Name"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="fixed-high">
          <el-form-item :label="$t('personalDetails1.Surname')" prop="Surname">
            <el-input v-model="formData.Surname"></el-input>
          </el-form-item>
        </el-col>
        <el-col v-show="formData.Title == 'Other'" :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="fixed-high">
          <el-form-item :label="$t('personalDetails1.OtherTitle')" prop="OtherTitle">
            <el-input v-model="formData.OtherTitle"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="fixed-high">
          <el-form-item :label="$t('personalDetails1.Gender')" prop="Gender">
            <el-select @visible-change="$elui_Select_Edge"  v-model="formData.Gender" class="select-width" :placeholder="$t('messages.unSelect')">
              <el-option v-for="(item,index) in $t('personalDetails1.genderSelect')" :key="index" :label="item" :value="index">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="fixed-high">
          <el-form-item :label="$t('personalDetails1.Lang')" prop="Lang">
            <el-select @visible-change="$elui_Select_Edge"  v-model="formData.Lang" class="select-width" :placeholder="$t('messages.unSelect')">
              <el-option v-for="(item,index) in $t('personalDetails1.emailLanguages')" :key="index" :label="item"
                :value="index">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="fixed-high">
          <el-form-item :label="$t('personalDetails1.Email')" prop="Email">
            <el-input onpaste="return false" id="Email" v-model="formData.Email" @blur="queryInfoByEmail(formData.Email)"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="fixed-high">
          <el-form-item :label="$t('personalDetails1.Email_Confirm')" prop="Email_Confirm">
            <el-input onpaste="return false" v-model="formData.Email_Confirm"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="fixed-high">
          <el-form-item :label="$t('personalDetails1.Country')" prop="Country">
            <el-select @visible-change="$elui_Select_Edge"  v-model="formData.Country" class="select-width" id="Country" filterable :placeholder="$t('messages.unSelect')">
              <el-option v-for="(item,index) in CountrySelect" :key="index" :label="item" :value="index"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="fixed-high">
          <el-form-item :label="$t('personalDetails2.Phone')" prop="Phone" class="form-item1">
            <el-input v-model="formData.Phone" id="Phone" class="input-with-select"  suffix-icon="el-icon-circle-close-outline"  clearable >
              <el-select @visible-change="$elui_Select_Edge"  style="width:150px;" v-model="curPhoneCode" slot="prepend"  @change="changePhone(curPhoneCode)" :placeholder="$t('messages.unSelect')" >
                <el-option :value="item" v-for="(item,key) in telphoneCode" :key="key" :label="countryTitleList.includes(key) ? '+'+item + '(' + key + ')' : item" v-if="countryTitleList.includes(key)">
                </el-option>
              </el-select>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="fixed-high">
          <el-form-item :label="$t('personalDetails1.Account_Type')" prop="Account_Type">
            <el-select @visible-change="$elui_Select_Edge"  v-model="formData.Account_Type" class="select-width" :placeholder="$t('messages.unSelect')">
              <el-option v-for="(item,index) in AccountTypeSelect" :key="index" :label="item"
                :value="index">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="fixed-high">
          <el-form-item :label="$t('personalDetails1.MT4_Currency')" prop="MT4_Currency">
            <el-select @visible-change="$elui_Select_Edge"  v-model="formData.MT4_Currency" class="select-width" :placeholder="$t('messages.unSelect')">
              <el-option v-for="(item,index) in MT4CurrencySelect" :key="index" :label="item"
                :value="index">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
  import {mapState} from 'vuex';
  import {URL_SAVEPERSONINFO, URL_VERIFY, URL_CREATELEAD,URL_CREATECAMPAIGNLEAD, URL_QUERY_INFO_BY_EMAIL, URL_CREATE_LEAD_AND_CAMPAIGN_LEAD} from '@/api/api.js';
  import {getCountries } from '@/assets/js/uitl';
  import getUploadFileByCountry from "@/assets/js/getUploadFileByCountry.js";
  import { TELPHONE  } from "../../commons/js/tel.js";
  import { log } from 'util';
  import Cookies from 'js-cookie';

  export default {
    name: 'personalDetail1',
    mixins: [
      require("@/assets/mixin/base.js").base('personalDetails1')
    ],
    props: ['Lead', 'AA_Number', 'middle_dataware'],
    data() {
      var that = this;
      const reEnterEmail = (rule, value, callback) => {
        if (value != this.formData.Email) {
          return callback(new Error(this.$t("customErrMsg.fieldIsRequired.Email_Confirm")));
        }
        callback()
      }
      const emailLanguage = (rule, value, callback) => {
        if (!value || value == '') {
          return callback(new Error(this.$t("customErrMsg.fieldIsRequired.Lang")));
        }
        callback()
      }
      const OtherTitle = (rule, value, callback) => {
        if (this.formData.Title != "Other") callback()
        if (!value || value == '') {
          return callback(new Error(this.$t("customErrMsg.fieldIsRequired.OtherTitle")));
        }
        callback()
      }
      const country = (rule, value, callback) => {
        if (!value || value == '') {
          return callback(new Error(this.$t("customErrMsg.fieldIsRequired.Country")));
        }
        callback()
      }
      const phone = (rule, value, callback) => {
        var str = /^((\(\+\)?)|(\d{1,})|(\+?\d{1,})|(\+?\d{1,}[\/\s.-])|(\(\+?\d{1,}\)\s))?(\(\d{1,}\))?[\/\s.-]?[\s]?(\d{1,}[\/\s.-])*?\d{1,}$/;
        var str2 = /^[\d,(,),\s,+,-,/,\.]{12,}/;  // 俄罗斯
        if (!value || value == '')return callback(this.$t('customErrMsg.fieldIsRequired.Phone'));
        if (str.test(value)) return callback();
        if (str2.test(value)) return callback();
        return callback(this.$t('errors.phoneError'));
      }
      const isLegalEmail = (rule, value, callback) => {
        if (!value || value == '') {
          return callback(new Error(this.$t("customErrMsg.fieldIsRequired.Email")));
        }
        var reg = /^([A-Za-z0-9_\-\.\u4e00-\u9fa5])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,3})$/;
        if (!reg.test(value)) {
          callback(new Error(this.$t("customErrMsg.fieldIsRequired.Email")));
        } else {
          callback()
        }
      }
      return {
        rulesArr:[
          {name: "Title",type: "select",rules: [{required: true}]},
          {name: "OtherTitle",type: "input",rules: [{required: true,validator:OtherTitle},{max: 200}]},
          {name: "First_Name",type: "input",rules: [{required: true},{max: 200}]},
          {name: "Surname",type: "input",rules: [{required: true},{max: 200}]},
          {name: "Gender",type: "select",rules: [{required: true}]},
          {name: "Email",type: "input",rules: [{required: true,validator: isLegalEmail},{max: 200}]},
          {name: "Email_Confirm",type: "input",rules: [{required: true,validator: reEnterEmail},{max: 200}]},
          {name: "Lang",type: "select",rules: [{required: true,validator:emailLanguage}]},
          {name: "Country",type: "select",rules: [{required: true,validator:country}]},
          {name: "Phone",type: "input",rules: [{required: true,validator: phone},{max: 25}]},
          {name: "Account_Type",type: "select",rules: [{required: true}]},
          {name: "MT4_Currency",type: "select",rules: [{required: true}]},
        ],
        MT4CurrencySelect:null,
        AccountTypeSelect:null,
        uploadFileType:[],
        curPhoneCode: this.formData.curPhoneCode,
        countryTitleList: ["HKG", "GBR", "CHN", "MYS", "THA", "PHL", "TWN", "KOR", "AFG", "ALB", "ALG", "AND", "AIA", "ATG",
          "ARG", "ARM", "ABW", "AUS", "AUT", "AZE", "BHS", "BHR", "BGD",
          "BRB", "BLR", "BEL", "BLZ", "BEN", "BMU", "BHU",
          "BOL", "BWA", "BVT", "BRA", "BRN", "BGR", "BFA", "BDI", "KHM", "CMR", "CAN", "CPV", "CYM", "CAF", "TCD",
          "CHL", "CCK", "COL", "COM", "COK", "CRI", "CIV", "HRV",
          "CUB", "CYP", "CZE", "DNK", "DJI", "DMA", "DOM", "EGY", "SLV", "ERI", "EST", "ETH", "FJI", "FIN", "FRA",
          "PYF", "GAB", "GEO", "DEU", "GHA", "GIB", "GRC", "GRL", "GRD",
          "GLP", "GTM", "GIN", "GNB", "HTI", "HMD", "HND", "HUN", "ISL", "IND", "IDN", "IRI", "IRQ ", "IRL", "ISR",
          "ITA", "JAM", "JPN", "JOR", "KAZ", "KEN", "KIR", "KWT",
          "KGZ", "LAO", "LVA", "LBN", "LSO", "LBR", "LBY", "LIE", "LTU", "LUX", "MAC", "MDG", "MWI", "MDV", "MLI",
          "MLT", "MHL", "MTQ", "MRT", "MUS", "MYT", "MEX", "MDA",
          "MCO", "MNG", "MNE", "MSR", "MAR", "MOZ", "NAM", "NRU", "NPL", "NLD", "NCL", "NZL", "NIC", "NER", "NGA",
          "NIU", "NFK", "NOR", "OMN", "PAK", "PSE", "PRY", "PER",
          "PCN", "POL", "PRT", "QAT", "ROU", "RUS", "RWA", "SHN", "KNA", "LCA", "SPM", "VCT", "WSM", "SMR", "STP",
          "SAU", "SEN", "SRB", "SYC", "SLE", "SGP", "SVK", "SVN", "ZAF",
          "ESP", "LKA", "SUR", "SJM", "SWZ", "SWE", "CHE", "SYR", "TJK", "TZA", "TLS", "TGO", "TON", "TTO", "TUN",
          "TUR", "TKM", "TCA", "TUV", "UAE", "UKR", "ARE",
          "URY", "UZB", "VUT", "VAT", "VEN", "VNM", "WLF", "ESH", "YEM", "ZMB", "SDN"
        ],
        countryList: {},
        curCountry: this.formData.country,
        queryInfoByEmailArray: [],
      }
    },
    mounted(){
       _g.trackStepPage(1);
       let language = Cookies.get('language');
       language = language != '' ? language : 'en';
       console.log('language====',language)
      switch(language){
        case "en":
          this.formData.Lang = 'ENG';
          break;
        case "cn":
          this.formData.Lang = 'CHS';
          break;
        case "hk":
          this.formData.Lang = 'CHT';
          break;
        case "ar":
          this.formData.Lang = 'ARA';
          break;
        case "hi":
          this.formData.Lang = 'HIN';
          break;
        case "ur":
          this.formData.Lang = 'URD';
          break;
        case "es":
          this.formData.Lang = 'ESP';
          break;
        case "it":
          this.formData.Lang = 'ITA';
          break;
        case "de":
          this.formData.Lang = 'GER';
          break;
        case "pt":
          this.formData.Lang = 'PTG';
          break;
        default:
          this.formData.Lang = 'ENG';
          break;  
      }
      this.getOptByCountry(this.formData.Country)
      this.getcountryList;
    },
    computed:{
      rules(){
        return this.$getRules(this.rulesArr);
      },
      CountrySelect(){
        return getCountries(this.$t('personalDetails1.countrySelect'));
      },
      telphoneCode() {
        // 区号列表
        // return TELPHONE.sort();
        let telKey = Object.keys(TELPHONE).sort((a, b) => TELPHONE[a] - TELPHONE[b])
        let result = {}
        for (let val of telKey) {
          result[val] = TELPHONE[val]
        }
        return result
      },
      getcountryList: {
        get: function() {
          // 国家列表
          let countyList = {};
          for (let i = 0; i < this.countryTitleList.length; i++) {
            for (let key in this.formData.Country) {
              if (this.countryTitleList[i] == key) {
                countyList[this.countryTitleList[i]] = this.formData.Country[key]
              }
            }
          }
          this.countryList = countyList;
        },
        set(val) {
          this.countryList = val;
        }
      },
    },
    methods: {
      selectTitle() {
        let fields = this.$refs["ruleForm"].fields
        if (this.formData.Title != 'Other') {
          Util.resetField(["OtherTitle"], fields,this.formData)
        }
      },
      getPageFormData(cb){
        this.$refs["ruleForm"].validate(async (valid) => {
          await this.verifyMessage();
          if (valid) {
            this.createLead()
            this.selectTitle();
            if(this.$parent.$parent.isFirstClick) await this.savePersonalDetails1Data();
            return cb(true);
          } else {
            // return cb(true);
            return cb(false);
          }
        });
      },
      verifyMessage(){
        return new Promise((resolve, reject)=>{
          let obj = {};
          obj.Email = this.formData.Email;
          obj.Phone = this.formData.Phone;
          if (!obj.Email || !obj.Phone ){
            return ;
          }
          URL_VERIFY(obj).then(res=>{
            if(res.data.msg == 'Phone exist') {
              return this.$alert(this.$t('verifyMsg.phone_exist'), this.$t('ModalMsg.showAlert.title'), {
                confirmButtonText: this.$t('ModalMsg.showModal.btn'),
                dangerouslyUseHTMLString: true,
              })
            }
            if(res.data.msg == 'Email exist') {
              return this.$alert(this.$t('verifyMsg.email_exist'), this.$t('ModalMsg.showAlert.title'), {
                confirmButtonText: this.$t('ModalMsg.showModal.btn'),
                dangerouslyUseHTMLString: true,
              })
            }
          if(res.data.msg == 'Phone&Email exist') {
              return this.$alert(this.$t('verifyMsg.phoneAndemail_exist'), this.$t('ModalMsg.showAlert.title'), {
                confirmButtonText: this.$t('ModalMsg.showModal.btn'),
                dangerouslyUseHTMLString: true,
              })
            }
            if(res.data.msg == 'success') resolve()
          }).catch((err)=>{
            reject();
          })
        })
      },
      savePersonalDetails1Data(){  //保存当前页数据
        return new Promise((resolve,reject)=>{
          let obj = {};
          obj.Gender = this.formData.Gender;
          obj.First_Name = this.formData.First_Name;
          obj.Surname = this.formData.Surname;
          obj.Email = this.formData.Email;
          obj.Lang = this.formData.Lang;
          URL_SAVEPERSONINFO(obj).then(res=>{
            this.$parent.$parent.isFirstClick = false;
            return resolve(true);
          }).catch((err)=> {
              reject();
          })
        })
      },
      createLead() {
        const aanumber = _g.getCookie('aanumber') || _g.generateAAnumber()
        _g.setCookieForAAnumber(aanumber)
        let obj = {
          LastName: this.formData.First_Name +' '+ this.formData.Surname,
          Company: 'N/A',
          MobilePhone: this.formData.Phone,
          Email: this.formData.Email,
          Entity__c: 'UK',
          AFF_ID__c: Cookies.get("AFF_ID__c") || '',
          CXD_token__c: Cookies.get("CXD_token") || '',
          LeadSource: 'Live Application',
          utm_campaign__c: Cookies.get("utm_campaign") || '',
          utm_content__c: Cookies.get("utm_content") || '',
          utm_medium__c: Cookies.get("utm_medium") || '',
          utm_source__c: Cookies.get("utm_source") || '',
          utm_term__c: Cookies.get("utm_term") || '',
          Landing_Page_Id__c: window.location.href || '',
          Referrer_Code__c: Cookies.get("Referrer_Code") || '',
          Referrer_Group__c: Cookies.get("Referrer_Group") || '',
          Referrer_Type__c: Cookies.get("Referrer_Type") || '',
          Registered_Country__c: this.formData.Ip_Country,
          Registered_IP__c: this.formData.Registered_IP,
          Country_of_Residence_Lead__c: this.formData.Country,
          Browser_language_Lead__c: navigator.language || navigator.browserLanguage,
          Email_language_lead__c: this.formData.Lang,
          Application_Page__c:1,
          Registered_City__c:this.formData.Ip_City,
          AA_Number__c: aanumber,
          middle_lead_id: this.middle_dataware.middle_lead_id,
          middle_campaignlead_id: this.middle_dataware.middle_campaignlead_id,
          middle_account_id: this.middle_dataware.middle_account_id,
          is_new_lead: this.middle_dataware.is_new_lead,
          Surname: this.formData.Surname
        }
        if(this.Lead.data === JSON.stringify(obj)) return
        this.Lead.data = JSON.stringify(obj);
        // obj.Id = this.Lead.id || ''
        // URL_CREATELEAD(obj).then(res=>{
        //   this.Lead.id = res.data.id
        // })
        // obj.sf_campaignlead_id = this.Lead.sf_campaignlead_id || ''
        // obj.Surname = this.formData.Surname

        // URL_CREATECAMPAIGNLEAD(obj).then(res=>{
        //   this.Lead.sf_campaignlead_id = res.data.id
        // })
        URL_CREATE_LEAD_AND_CAMPAIGN_LEAD(obj).then(res => {
          console.log(res.data)   
          const data = res.data.data     
          this.middle_dataware.middle_lead_id = data.middle_lead_id || ""
          this.middle_dataware.middle_campaignlead_id = data.middle_campaignlead_id || ""
          this.middle_dataware.middle_account_id = data.middle_account_id || ""
          this.middle_dataware.is_new_lead = data.is_new_lead || 0
          if (data.aanumber) _g.setCookieForAAnumber(data.aanumber)
          if (data.leadid) _g.setCookieForLeadid(data.leadid)
        }).catch(e => {
          console.error(e)
        })
      },
      getOptByCountry(val){
        if(['GBR', 'IRL'].includes(val)){
          this.AccountTypeSelect = this.$t("personalDetails1.Account_TypeSelect");
        }else{
          this.AccountTypeSelect = {CFDs:this.$t("personalDetails1.Account_TypeSelect.CFDs")};
        }

        let USDCountryArr = ['CHN','TWN','BHR','BGD','KHM','EGY','IND','IDN','ISR','JPN','JOR','KWT','LBY','MYS','MDV','MNG','MAR','OMN','PAK','PHL','QAT','SAU','SGP','THA','TUN','TUR','VNM','ARE'];
        let GBRCountryArr = ['IRL']
        if(USDCountryArr.includes(val)){
          this.MT4CurrencySelect = {USD:this.$t("personalDetails1.MT4CurrencySelect['USD']")};
        }else{
          if( (['GBR'].includes(val)&&['SpreadBetting'].includes(this.formData.Account_Type))  || GBRCountryArr.includes(val) ){
            this.MT4CurrencySelect = {GBP:this.$t("personalDetails1.MT4CurrencySelect['GBP']")};
          } else {
            this.MT4CurrencySelect = this.$t('personalDetails1.MT4CurrencySelect')
          }
        }
      },
      changePhone(item) {  //电话的国号更改
        let telphoneCode= this.telphoneCode
        for(let key in telphoneCode) {
          if(item!=undefined&&item!=""){
            if (telphoneCode[key] == item) {
              this.formData.curPhoneCode = item
            }
          }
        }
      },
      // 根据邮箱查询中间库账号信息
      async queryInfoByEmail(email){
        // 邮箱验证
        const emailValidation = this.rules.Email[0]
        if (emailValidation.required) {
          const validated = await new Promise((resolve, reject) => {
            emailValidation.validator(null, email, err => {
              return err ? resolve(false) : resolve(true)
            });
          })
          if (!validated) return false
        }

        // 查询邮箱频率限制
        if (this.queryInfoByEmailArray.length > 5) return false
        // 已经查询过的email不再查询
        for (const data of this.queryInfoByEmailArray) {
          if (data.email === email) {
            _g.setCookieForAAnumber(data.aanumber)
            _g.setCookieForLeadid(data.leadid)
            return false
          }
        }

        const obj = {}
        obj.email = email
        URL_QUERY_INFO_BY_EMAIL(obj).then(res => {
          console.log(res.data)
          const data = res.data.data
          const code = res.data.code
          if (code == 200) {
            _g.setCookieForAAnumber(data.aanumber)
            _g.setCookieForLeadid(data.leadid)
            this.queryInfoByEmailArray.push({...data, ...obj})
          }
        }).catch(e => {
          console.error(e)
        })
      }
    },
    watch: {
      'formData.Country'(val){
        if(!this.countryTitleList.includes(val)) this.formData.country = null
        this.curCountry = val
        this.curPhoneCode = this.telphoneCode[val]
        this.formData.curPhoneCode = this.curPhoneCode
        this.getOptByCountry(val)
        this.formData.MT4_Currency = null;
        this.formData.Hear_ATFX = null;
        this.formData.Account_Type = null;
        this.$store.commit('SAVEUPLOADFILETYPE',getUploadFileByCountry(val));
        Cookies.set('GTM_COUNTRY', val);
      },
      'formData.Account_Type'(val){
        let obj={};
        if(['GBR'].includes(this.formData.Country)){
          if(['SpreadBetting'].includes(val)){
            this.MT4CurrencySelect = {GBP:this.$t("personalDetails1.MT4CurrencySelect['GBP']")};
            obj['K_Sell_Position'] = this.$t('Knowledge.K_Sell_Position_b');
            obj['K_Profit_Change'] = this.$t('Knowledge.K_Profit_Change_b');
          }else{
            this.MT4CurrencySelect = this.$t('personalDetails1.MT4CurrencySelect')
            obj['K_Sell_Position'] = this.$t('Knowledge.K_Sell_Position');
            obj['K_Profit_Change'] = this.$t('Knowledge.K_Profit_Change');
          }
          this.formData.MT4_Currency = '';
        }else{
          obj['K_Sell_Position'] = this.$t('Knowledge.K_Sell_Position');
          obj['K_Profit_Change'] = this.$t('Knowledge.K_Profit_Change');
        }
        this.$store.commit("SAVEKNOWLEDGE",obj)
      },
      "formData.curPhoneCode"(val) {
        this.curPhoneCode = this.formData.curPhoneCode
      }
    }
  }

</script>

<style lang="scss">
  body{
    font-family: Muli-Regular;
  }

  .el-scrollbar {
    > .el-scrollbar__bar {
      opacity: 1 !important;
    }
  }

  .el-form-item--small .el-form-item__label,.el-form-item--small .el-form-item__content {
    line-height: normal;
  }
  .personal-detail-1 {
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;

    .form-tip {
      font-size: 11px;
      color: #939597;
      padding: 10px 0;
    }
    .fixed-high{
      height: 93px;
    }

    .time-icon-color {
      color: #f2672a;
      margin-right: 10px;
    }

    .select-width {
      width: 100%;
    }
    .el-form-item__label{
      color: black;
    }
  }
.form-item1 .el-form-item.is-error .el-input__inner,.form-item1 .el-input-group .el-input__inner{
  display: inherit;
}
</style>



// WEBPACK FOOTER //
// src/view/steps/personal-detail-1.vue